<template>
  <div class="left-menu-wrapper">
    <v-navigation-drawer
      id="menu"
      v-model="drawer"
      class="base-card left-menu ml-10"
      width="285"
      mobile-breakpoint="xs"
      absolute app floating permanent
      :mini-variant="mini"
      :mini-variant-width="72"
      :clipped="false"
    >
      <v-card class="whiteBlack">
        <v-card-title class="justify-end pa-2">
          <v-btn
            icon small class="ml-4"
            plain :title="mini ? 'Показать меню' : 'Скрыть меню'"
            @click="mini = !mini"
          >
            <v-icon class="uikit-icon chevron-left-circle delay-03" :class="mini ? 'rotate-180' : ''" />
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-2 pt-0">
          <MenuLinks
            :links="links"
            :mini="mini"
          />
        </v-card-text>
      </v-card>
    </v-navigation-drawer>

    <v-navigation-drawer
      id="menu-news"
      v-model="drawer"
      class="base-card left-menu-2 ml-10"
      width="285"
      mobile-breakpoint="xs"
      absolute app floating permanent
      :mini-variant="mini"
      :mini-variant-width="72"
      :clipped="false"
    >
      <NewsLine :mini="mini" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import MenuLinks from '@/ui/MenuLinks'
import NewsLine from '@/components/Spm/NewsLine'

export default {
  name: 'UIMenu',

  components: { NewsLine, MenuLinks },

  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (document.getElementById('menu') && document.getElementById('menu-news')) {
        const heightTopMenu = document.getElementById('menu').clientHeight + 100
        document.getElementById('menu-news').style.marginTop = `calc(${heightTopMenu}px + var(--tech-message-height))`
      }
    })
  },

  data: () => ({
    drawer: false,
    mini: false,
  }),
}
</script>

<style scoped lang="scss">
.left-menu {
  background: var(--v-background-base) !important;
  margin-top: calc(76px + var(--tech-message-height));
  /*max-height: 316px !important;*/
  height: auto !important;
}

.left-menu-wrapper {
  display: flex;
  flex-direction: column;
}

.left-menu-2 {
  height: auto !important;
}
</style>
